import {createCache, useCache} from '@react-hook/cache'
import type {CacheState, UseCacheStatus} from '@react-hook/cache'
import type {ThenArg} from '../types'

export const useDependency = <
  Deps extends typeof dependencies,
  Name extends Extract<keyof Deps, string>
>(
  name: Name
): [
  // @ts-ignore
  ThenArg<ReturnType<Deps[Name]>>,
  {
    error?: Error
    status: UseCacheStatus
    // @ts-ignore
    retry: () => Promise<CacheState<ThenArg<ReturnType<Deps[Name]>>, Error>>
  }
] => {
  const [{error, status, value}, loadDeps] = useCache(dependencyCache, name)

  if (status === 'idle') {
    loadDeps()
  }

  return [value || {}, {error, status, retry: loadDeps}]
}

const dependencyCache = createCache(
  // @ts-ignore
  <Deps extends typeof dependencies, Name extends Extract<keyof Deps, string>>(
    name: Name
    // @ts-ignore
  ): ReturnType<Deps[Name]> => dependencies[name]()
)

useDependency.preload = dependencyCache.load.bind(dependencyCache)

const dependencies = {
  'react-ace': () =>
    import(/* webpackChunkName: "react-ace" */ 'react-ace').then((module) =>
      Promise.all([
        // import(
        //   /* webpackChunkName: "ace-mode-tsx" */
        //   'ace-builds/src-noconflict/mode-tsx'
        // ),
        import(
          /* webpackChunkName: "ace-mode-jsx" */
          'ace-builds/src-noconflict/mode-jsx'
        ),
        import(
          /* webpackChunkName: "ace-mode-javascript" */
          'ace-builds/src-noconflict/mode-javascript'
        ),
        // import(
        //   /* webpackChunkName: "ace-mode-typescript" */
        //   'ace-builds/src-noconflict/mode-typescript'
        // ),
        import(
          /* webpackChunkName: "ace-theme-nord_dark" */
          'ace-builds/src-noconflict/theme-nord_dark'
        ),
        import(
          /* webpackChunkName: "ace-keybinding-vscode" */
          'ace-builds/src-noconflict/keybinding-vscode'
        ),
      ]).then(() => module.default)
    ),
  buble: () => import(/* webpackChunkName: "buble" */ 'buble'),
  // acorn: () =>
  //   import(/* webpackChunkName: "acorn" */ 'acorn').then(async (acorn) => {
  //     const jsx = await import(/* webpackChunkName: "acorn-jsx" */ 'acorn-jsx')
  //     return {Parser: acorn.Parser.extend(jsx.default()), ...acorn}
  //   }),
}
